import jp from 'jsonpath';

export const replaceJsonPathBuzzwords = (
  data: Record<string, any> | undefined,
  text: string | undefined
): string => {
  if (text === undefined) return '';
  const tokens: string[] = text.match(/\$\.[\w.]+/g) ?? [];
  return tokens.reduce((result, token) => {
    const value = data ? jp.value(data, token) : undefined;
    return value != null ? result.split(token).join(String(value)) : result;
  }, text);
};

export const decodeIfEncoded = (value: string): string => {
  if (!/%[0-9A-Fa-f]{2}/.test(value)) return value;
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

export const resolveFieldValue = (
  formValues: Record<string, any>,
  fieldName: string
): string | null => {
  const value = formValues?.[fieldName];
  return value != null && value !== '' ? String(value) : null;
};
